import React, { useState, useRef, useEffect } from "react";
import { MyCustomContextHook } from "./Context";
const ExtraSubmenus = () => {
  const {
    label: {subMenus, icons },

    extraSubmenu,
  } = MyCustomContextHook();



 
  return (
    <>
      <aside
        className={`${extraSubmenu ? "extra-submenu-container show" : "extra-submenu-container"}`}

      >
        <div>
          <div className="extra-sub">
            {subMenus ? subMenus.map((subMenu, index) => {
              const { category } = subMenu;
              return (
                <>
                  <div key={index} className = 'category-style'>
                    {category}
                  </div>
                </>
              );
            }) : null}
          </div>
        </div>
      </aside>
    </>
  );
};

export default ExtraSubmenus;
